import type { FieldDto } from "../../types/field";
import { birthdateValidationMessage, isValidDateSubmit } from "./dateField";
import { dateRangeValidationMessage } from "./dateRangeField";
import { getBirthdateAgeLimits, isDateWithTime } from "./fieldOptions";
import { numberValidationMessage, resolveNumberConfig } from "./numberField";
import { resolveFieldType } from "./normalizeFieldType";
import { validateEmail, validatePhone, validateRequired } from "../validators";

export function getFieldValidation(
  field: FieldDto,
): (value: string) => boolean {
  switch (resolveFieldType(field.type)) {
    case "email":
      return field.required
        ? validateEmail
        : (value) => !value.length || validateEmail(value);
    case "phone":
      return field.required
        ? validatePhone
        : (value) => !value.length || validatePhone(value);
    case "date": {
      const withTime = isDateWithTime(field);
      return field.required
        ? (value) => isValidDateSubmit(value, withTime)
        : (value) => !value.length || isValidDateSubmit(value, withTime);
    }
    case "date-range": {
      const withTime = isDateWithTime(field);
      return (value) =>
        dateRangeValidationMessage(value, withTime, field.required) == null;
    }
    case "birthdate": {
      const limits = getBirthdateAgeLimits(field);
      return field.required
        ? (value) => birthdateValidationMessage(value, limits) == null
        : (value) =>
            !value.length || birthdateValidationMessage(value, limits) == null;
    }
    case "number": {
      const config = resolveNumberConfig(field);
      return (value) =>
        numberValidationMessage(value, config, field.required) == null;
    }
    case "privacy":
      return field.required ? (value) => value === "1" : () => true;
    case "display":
      return () => true;
    case "multiple-choice":
      return field.required
        ? (value) => {
            try {
              const parsed = JSON.parse(value || "[]") as unknown;
              return Array.isArray(parsed) && parsed.length > 0;
            } catch {
              return false;
            }
          }
        : () => true;
    default:
      return field.required ? validateRequired : () => true;
  }
}
